import React from 'react';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import TimelineMilestones from "./TimelineMilestones";

interface Data {
    timelineMilestoneGraphql: Array<{
        results: Array<{
            entityBundle: string;
            id: string;
            year: number;
            title: string;
            fieldBackgroundColor: string;
            fieldBackgroundImageMedia: Array<{}>;
            fieldSupportingImageMedia: Array<{}>;
            fieldColumnContent: Array<{}>;
        }>;
    }>;
}

class TimelineMilestonesGraphQLQuery extends Query<Data, {}> {}

const GET_COMPONENT = gql`
query {
    timelineMilestoneGraphql: nodeQuery(limit: 10000,
        filter: {conditions: [{operator: EQUAL, field: "type", value: ["timeline_milestone"]}], conjunction: OR}
    ) {
        results: entities {
        ... on NodeTimelineMilestone {
          entityBundle
          id: entityId
          year: fieldYear
          title: entityLabel
          fieldBackgroundColor
          fieldBackgroundImageMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                      url
                      alt
                  }
                }
              }
          }
          fieldSupportingImageMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                      url
                      alt
                    }
                  }
              }
          }
          fieldColumnContent {
            value
            format
            processed
          }
        }
      }
    }
  }
`;

const TimelineMilestoneQuery = () => (
    <TimelineMilestonesGraphQLQuery asyncMode query={GET_COMPONENT}>
        {({ loading, error, data }) => {
            if (loading) return (
                <div className="timelineMilestoneLoader">
                    <span className="far fa-spin fa-spinner"/>
                </div>
            );
            if (error || !data.timelineMilestoneGraphql) {
                return <div>{error || null}</div>;
            }

            const milestones = data.timelineMilestoneGraphql.results;
            if (!milestones.length) return null;

            return (<TimelineMilestones milestones={milestones}/>);
        }}
    </TimelineMilestonesGraphQLQuery>
);

export default TimelineMilestoneQuery;



// WEBPACK FOOTER //
// ./frontend/components/TimelineMilestone/TimelineMilestoneQuery.jsx